// Interface that allows events to be included in a timeline
export interface ITimelineEvent {
  timestamp: number;
}
